import React from "react";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import { company } from "../data/siteData";

const titles = {
  "/": "RYU株式会社｜酒類の可能性を、広げる。",
  "/company": "会社情報 | RYU株式会社",
  "/contact": "お問い合わせ | RYU株式会社",
  "/faq": "よくあるご質問 | RYU株式会社",
  "/faqplus": "偽物ウイスキーの見分け方 | RYU株式会社",
};
const SiteMetadata = () => {
  const { pathname } = useLocation();
  const title = titles[pathname] || "ページが見つかりません | RYU株式会社";
  return (
    <Helmet>
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta
        name="twitter:description"
        content="酒類卸売・EC・流通を展開するRYU株式会社。商品・お取引に関するご相談を承ります。"
      />
      <meta name="twitter:image" content="https://www.ryukk.jp/ogp.jpg" />
      <meta property="og:site_name" content={company.name} />
      <meta property="og:locale" content="ja_JP" />
      <meta property="og:image" content="https://www.ryukk.jp/ogp.jpg" />
      {pathname === "/" && (
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            name: company.name,
            url: "https://www.ryukk.jp/",
            logo: "https://www.ryukk.jp/logo.png",
            telephone: company.phone,
            email: company.email,
            foundingDate: "1947-10",
            address: {
              "@type": "PostalAddress",
              streetAddress: company.address,
              postalCode: company.postalCode,
              addressCountry: "JP",
            },
            sameAs: company.marketplace.map((item) => item.href),
          })}
        </script>
      )}
    </Helmet>
  );
};
export default SiteMetadata;
